<template>
  <div :id="this.id">
     
  </div>
</template>

<script>
import * as d3 from "d3";
export default {
  name: "PieChart",
  props:{
    opcions: Array,
    id: String
  },
  data() {
    return {
      height: 300,
      width: 300
    };
  },
  methods: {
    generateChart() {
      // set the dimensions and margins of the graph
      var width = 550,
      height = 450,
      margin = 20;

      // The radius of the pieplot is half the width or half the height (smallest one). I subtract a bit of margin.
      var radius = Math.min(width, height) / 2 - margin

      // append the svg object to the div called 'pieChart'
      var svg = d3.select("#"+this.id)
        .append("svg")
          .attr("width", width)
          .attr("height", height)
        .append("g")
          .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

      // Create dummy data      
      //var data = {a: 9, b: 20, c:30, d:8, e:12, f:3, g:7, h:14}
      

      // set the color scale
      var color = d3.scaleOrdinal()
        //.domain(["2", "b", "c", "d", "e", "f", "g", "h"])
        .range(d3.schemeDark2);

      // Compute the position of each group on the pie:
      var pie = d3.pie()
        .sort(null) // Do not sort group by size
        .value(function(d) {return d.value.percentatge; })
      var data_ready = pie(d3.entries(this.opcions))

      // The arc generator
      var arc = d3.arc()
        .innerRadius(radius * 0.0)         // This is the size of the donut hole
        .outerRadius(radius * 0.7)

      // Another arc that won't be drawn. Just for labels positioning
      var outerArc = d3.arc()
        .innerRadius(radius * 0.85)
        .outerRadius(radius * 0.85)

      // Build the pie chart: Basically, each part of the pie is a path that we build using the arc function.
      svg
        .selectAll('allSlices')
        .data(data_ready)
        .enter()
        .append('path')
        .attr('d', arc)
        .attr('fill', function(d){return(color(d.data.key)) })
        .attr("stroke", "white")
        .style("stroke-width", "1px")
        .style("opacity", 0.8)

      // Add the polylines between chart and labels:
      svg
        .selectAll('allPolylines')
        .data(data_ready)
        .enter()
        .append('polyline')
          .attr("stroke", "black")
          .style("fill", "none")
          .style("opacity", 0.6)
          .attr("stroke-width", 1)
          .attr('points', function(d) {
            var posA = arc.centroid(d) // line insertion in the slice
            var posB = outerArc.centroid(d) // line break: we use the other arc generator that has been built only for that
            var posC = outerArc.centroid(d); // Label position = almost the same as posB
            var midangle = d.startAngle + (d.endAngle - d.startAngle) / 2 // we need the angle to see if the X position will be at the extreme right or extreme left
            posC[0] = radius * 0.95 * (midangle < Math.PI ? 1 : -1); // multiply by 1 or -1 to put it on the right or on the left
            return [posA, posB, posC]
          })

        // Add the polylines between chart and labels:
        svg
          .selectAll('allLabels')
          .data(data_ready)
          .enter()
          .append('text')
          .call(text => text.append("tspan")
                        .attr("y", "-0.4em")
                        .attr("font-weight", "bold")
                        .attr("font-size","12")
                        .text(d =>  d.data.value.opcio.descripcio.text))
          .call(text => text.append("tspan")
                        .attr("x", 0)
                        .attr("y", "0.8em")
                        .attr("fill-opacity", 0.7)
                        .text(d => d.data.value.percentatge+"%"))                        
            //.text( function(d) { return d.data.value.country } )
          .attr('transform', function(d) {
                var pos = outerArc.centroid(d);
                var midangle = d.startAngle + (d.endAngle - d.startAngle) / 2
                pos[0] = radius * 0.99 * (midangle < Math.PI ? 1 : -1);
                return 'translate(' + pos + ')';
          })
          .style('text-anchor', function(d) {
                var midangle = d.startAngle + (d.endAngle - d.startAngle) / 2
                return (midangle < Math.PI ? 'start' : 'end')
          })


    }

  },
  mounted() {    
    this.generateChart();
  }
};
</script>

<style>
</style>